import React from 'react';

import { StyledDropdown } from './styles';
import type { NavWrapperProps } from './types';
import { SimpleNav } from './';

export const NavWrapper = ({
  className,
  links,
  variant = 'vertical',
}: NavWrapperProps): JSX.Element => {
  return (
    <nav className={className}>
      <StyledDropdown variant={variant}>
        {links
          ?.filter((link) => !link.hide)
          .map((item) => (
            <SimpleNav key={item.label} {...item} />
          ))}
      </StyledDropdown>
    </nav>
  );
};
